export default "__VITE_ASSET__DEdlGtt3__"